export default "__VITE_ASSET__BEEkn51W__"